/**
 * 🔊 StationNoise.js - noise levels of this station's recordings (user, 8 Oct 2026)
 *
 * What the engine measured in every uploaded recording (noiseLevels/{fileId}, read-only): ambient noise without
 * animal sounds and equipment noise, by file / hour of day / day / week / month / season / year, with CSV export.
 * Calibrated stations get dB re 1 µPa; without calibration (Settings → Recording site → Calibration) the levels are
 * relative (dB re full scale).
 */
import React, { useMemo } from 'react';
import { db } from '../../../firebase-config';
import NoiseView from '../../analyst/review/NoiseView';
import { stationNoiseSource, demoNoise } from '../../analyst/review/reviewData';
import '../../analyst/review/CallReview.css';

const StationNoise = ({ stationData }) => {
  const sid = stationData?.stationId ? String(stationData.stationId) : null;
  const preview = process.env.REACT_APP_ANALYSIS_DEMO === '1';
  const source = useMemo(() => {
    if (preview) return { list: async () => { const d = await demoNoise.list('community'); return { ...d, docs: d.docs.filter((x) => x.stationId === '502' || x.stationId === 'example-synthetic') }; } };
    return sid ? stationNoiseSource(db, sid) : null;
  }, [sid, preview]);
  if (!source) return <p>Loading station…</p>;
  return (
    <div className="hcr nz-station">
      {preview && <p className="nz-warn">PREVIEW: example data (one real recording and a synthetic year).</p>}
      <NoiseView source={source} title="Noise levels of your recordings" />
    </div>);
};

export default StationNoise;
